// extracted by mini-css-extract-plugin
export default {"Shadow":"eYUBBobi"};